import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import Profile from "../views/Profile.vue";
import AWSAccount from "../views/CreateAccount.vue";

import {authGuard} from "../auth/authGuard.js";

Vue.use(VueRouter)

  const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  //   beforeEnter: authGuard
  // },
  // {
  //   path: "/profile",
  //   name: "profile",
  //   component: Profile,
  //   beforeEnter: authGuard
  // },
  {
    path: "/",
    name: "account",
    component: AWSAccount,
    beforeEnter: authGuard
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
